import { useState, useEffect, useRef } from "react";

export function useApiData(fetcher, deps = [], syncInit = null) {
  const [data, setData] = useState(syncInit);
  const [loading, setLoading] = useState(syncInit === null);
  const [error, setError] = useState(null);
  // Track whether this is the first effect run for this instance so we don't
  // flash loading=true when the caller supplied synchronous initial data.
  const firstRunRef = useRef(true);

  useEffect(() => {
    let cancelled = false;
    if (!firstRunRef.current || syncInit === null) {
      setLoading(true);
    }
    firstRunRef.current = false;
    setError(null);
    fetcher()
      .then((result) => {
        if (!cancelled) {
          setData(result);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err);
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, loading, error };
}
